<template>
    <router-link :to="`/users/${user.id}`">
        <div
            class="px-4 py-1 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class="w-full flex items-center space-x-6 focus:outline-none">
                <div class="w-14 h-14 rounded-full border-4 border-gray-200 overflow-hidden">
                    <img
                        loading="lazy"
                        alt="user.lastName"
                        class="object-cover"
                        :src="parseUrl(user.photoURL)"
                    />
                </div>
                <div class="flex-1">
                    <div class="flex items-center space-x-4">
                        <h3 class="text-xl font-medium ml-2">
                            {{ user.name }}
                        </h3>
                        <span>{{ user.job }}</span>
                        <span
                            v-if="user.pauseTime"
                            class="text-red-600 font-bold bg-red-100 px-3 py-0.5 rounded-sm"
                            >giv停止</span
                        >
                        <ul
                            class="my-2 flex items-center flex-wrap space-x-2 space-y-1 justify-end space-x-1 max-w-4xl"
                        >
                            <li
                                v-for="item in user.areas"
                                :key="item.id"
                                class="text-xs text-teal-900 font-medium px-2 bg-teal-50 rounded-full"
                            >
                                {{ item.tag }}
                            </li>
                        </ul>
                    </div>
                    <div class="pl-2 pt-1 flex items-center space-x-4">
                        <ul class="space-x-1 flex flex-wrap items-center">
                            <li
                                v-for="s in userGroups"
                                :key="s.id"
                                class="border border-gray-300 rounded-full px-3 leading-6 text-xs font-medium text-gray-800"
                            >
                                <span>{{ s.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'UserCard',
    props: ['user'],
    computed: {
        userGroups() {
            return Object.keys(this.user.groups || {}).map(g => ({ id: g, label: g }))
        },
    },
    methods: {
        parseUrl(url) {
            if (!url) return url
            if (url.startsWith('http')) {
                return url
            }
            return `https://cdn.giv.link/${url}`
        },
    },
}
</script>
